import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    align-self: center;
    flex: 0 auto;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
`
